import { css } from 'lit';

export const customerHomePageStyles = css`
  .workspace {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
  }

  .workspace p {
    margin: var(--space-1) 0 0;
  }
`;
